"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartYourRenovationWithConfidence() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    once: true,
    threshold: 0.2
  });
  return <section id="start-your-renovation-with-confidence" ref={sectionRef} className="relative min-h-[456px] flex items-center justify-center overflow-hidden !shadow-none !m-0 !bg-[hsl(32,29%,42%)] ![padding:96px_0px_120px_0px]">
      {}
      <div className="absolute inset-0 z-0 !text-[hsl(32,29%,42%)] !bg-[rgba(138,109,76,0.7843137254901961)]" />

      {}
      <div className="relative z-10 max-w-[800px] px-6 text-center transition-all duration-[var(--duration-slow)] opacity-100 translate-y-0 ![margin:0px_145.2px_50px_145.2px]">
        <h2 className="font-display text-4xl font-semibold mb-6 leading-tight !text-[hsl(0,0%,100%)] md:text-5xl">Start Your Renovation with Confidence</h2>

        <p className="text-lg mb-8 leading-relaxed max-w-[700px] mx-auto !text-[hsl(0,0%,100%)]">Every project begins with a conversation.
Let <span className="font-semibold">KS LUXURY RENOVATIONS</span> guide you through a refined, transparent, and expertly managed renovation experience.</p>

        <Link to="https://ksluxury.cloudtech.com.cy/get-a-quote/" className="inline-block">
          <Button size="lg" className="text-primary-foreground px-6 inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs has-[>svg]:px-4 bg-accent font-semibold h-[60px] rounded-full shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] !m-0 ![padding:0px_40px_0px_40px] !text-[hsl(0,0%,100%)] !text-lg disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-accent-hover hover:shadow-strong hover:-translate-y-1 active:translate-y-0">Request a Consultation</Button>
        </Link>
      </div>
    </section>;
}